import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class LoadscreenService {
  constructor() {}
  loadingVisible = false;
  loadingMessage = '';


  initiateLoading(message: string) {
    this.loadingVisible = true;
    this.loadingMessage = message;
  }

  cancelLoading() {
    this.loadingVisible = false;
  }
}